<div [ngClass]="item.size">
    <div class='embed-responsive embed-responsive-16by9'>
        <iframe class="embed-responsive-item" [src]="item.url|safe" allowfullscreen></iframe>
    </div>
</div>